function snsQrCodeModal() {
  const modal = document.getElementById('sns-qrcode');
  if (modal) {
    const img = modal.querySelector('img');
    modal.addEventListener('show.bs.modal', ev => {
      const button = ev.relatedTarget;
      img.src = button.dataset.qrcodeSrc;
    });
  }
}

export default {
  everyPage() {
    app.el.$document.trigger('scroll');
    snsQrCodeModal();
  },
};
